import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../../constants/config";
import { apiCall } from "../../api/api_index";
import { showLoading } from "../slice/loadingslice";

const createAccountAsyncThunk = (method, type, url, contentType = "application/json") =>
  createAsyncThunk(type, async (payload, thunkAPI) => {
    const { data } = payload;
    const { dispatch } = thunkAPI;
    const token = localStorage.getItem("token");
    console.log("data:::", data);
    const apiRequest = {
      method: method,
      headers: token
        ? {
            "Content-Type": contentType,
            Authorization: "Token " + localStorage.getItem("token"),
          }
        : {
            "Content-Type": "application/json",
            accept: "application/json",
          },
      url: `${baseUrl}${url}`,
      data,
    };

    try {
      dispatch(showLoading.actions.toggleLoading(true));
      const res = await apiCall(apiRequest, dispatch);
      const response = res.data;

      // dispatch(showLoading.actions.toggleLoading(false));

      if (response.statusFlag === true) {
        console.log(`bin action ------ ${type}`, response);
        return response;
      } else {
        console.error(`bin action - ${type}`, response);

        // Check if there is an error code in the response
        const errorCode = response.message;

        // You can throw a custom error with the error code
        throw new Error(errorCode);
      }
    } catch (error) {
      dispatch(showLoading.actions.toggleLoading(false));
      throw error;
    }
  });

export const binUpload = createAccountAsyncThunk(
  "post",
  "binUpload",
  "voyance_admin/ota/ota_file_upload/",
  "multipart/form-data"
);
export const createNewCardio = createAccountAsyncThunk(
  "post",
  "createNewCardio",
  "voyance_admin/cardio_admin/cardio_account_creation/"
);
export const registerRentalDevice = createAccountAsyncThunk(
  "post",
  "registerRentalDevice",
  "voyance_admin/rental/add_rental_users/"
);
export const getRentalUsersList = createAccountAsyncThunk(
  "post",
  "getRentalUsersList",
  "voyance_admin/rental/get_rental_users/"
);
export const getRentalUsersDetails = createAccountAsyncThunk(
  "post",
  "getRentalUsersDetails",
  "voyance_admin/rental/rental_history_details"
);
export const getUnregisteredDevicesList = createAccountAsyncThunk(
  "get",
  "getUnregisteredDevicesList",
  "voyance_admin/device_info/get_device_list/"
);
export const generatePayout = createAccountAsyncThunk(
  "get",
  "generatePayout",
  "voyance_admin/rental/rental_doctor_earnings_details"
);
export const releasePayout = createAccountAsyncThunk(
  "post",
  "releasePayout",
  "voyance_admin/rental/rental_payout_details"
);
export const getPayoutList = createAccountAsyncThunk(
  "post",
  "getPayoutList",
  "voyance_admin/rental/rental_generate_transactions_details"
);
